/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit User/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function User({
  children,
  viewPath = "/DesignSystem/TasksFilters/AssignedTo/Content/SearchResult/Content/User"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isHovered
  
})
let filtersAssigneesValueData = fromData.useDataValue({ viewPath,
context: 'filters',
path: 'assignees',
})
let personIdValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'id',
})
let aggregateData = fromHelpers.isChecked(filtersAssigneesValueData, personIdValueData)
let personTextValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'text',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let personSubtextValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'subtext',
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtTypographyFontsizeMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.ms'
        })
  return (<React.Fragment
>
<button
  data-testid="User.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-1-bE5X': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-2-bE5X': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-3-bE5X': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-4-bE5X': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-5-bE5X': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-6-bE5X': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-7-bE5X': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-8-bE5X': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-9-bE5X': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--g-10-bE5X': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-11-bE5X': isHovered ? dtColorsNeutral200 : "transparent"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaCheckboxInput
  viewPath={`${viewPath}/TysiaCheckboxInput`}
 data="filters.assignees"
 data="person.id"
 aggregate="helpers.js isChecked"
 value={aggregateData}
 size="small"
/>
<div
  data-testid="User.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 backgroundColor={dtColorsNeutral900}
 data="person.text"
 text={personTextValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 fontSize={dtTypographyFontsizeMs}
 data="person.subtext"
 text={personSubtextValueData}
/>
</div>
</button>
{children}
</React.Fragment>)
}